// Advanced 3D Geometry Data - Organized for Supabase Migration
// Table: advanced_3d_geometry_sketches

export const ADVANCED_3D_GEOMETRY_DATA = [
  {
    id: "circular-cone-3d-001",
    category_id: "3d-geometry",
    name: "Circular Cone",
    description: "3D circular cone with height (h), radius (r), and slant height (l)",
    coordinates: "Base center at origin, apex at height h, radius r from center",
    type: "3D",
    difficulty_level: "intermediate",
    tags: ["cone", "3d", "circular", "geometry", "advanced"],
    default_params: {
      centerX: 200,
      centerY: 150,
      radius: 80,
      height: 128,
      showHeight: true,
      showRadius: true,
      showSlant: true,
      show3DAxes: true,
      baseFill: "rgba(100,100,100,0.3)",
      sideFill: "rgba(150,150,150,0.4)",
      stroke: "black",
      strokeWidth: 2,
      heightColor: "red",
      radiusColor: "blue",
      slantColor: "green"
    },
    parameter_config: [
      { name: "centerX", label: "Center X", type: "number", min: 0, max: 400 },
      { name: "centerY", label: "Center Y", type: "number", min: 0, max: 300 },
      { name: "radius", label: "Radius (r)", type: "number", min: 20, max: 150 },
      { name: "height", label: "Height (h)", type: "number", min: 30, max: 200 },
      { name: "slantHeight", label: "Slant Height (l)", type: "number", min: 30, max: 250 },
      { name: "baseFill", label: "Base Color", type: "color" },
      { name: "sideFill", label: "Side Color", type: "color" },
      { name: "stroke", label: "Edge Color", type: "color" },
      { name: "strokeWidth", label: "Edge Width", type: "number", min: 1, max: 5 },
      { name: "showHeight", label: "Show Height Line", type: "checkbox" },
      { name: "showRadius", label: "Show Radius Line", type: "checkbox" },
      { name: "showSlant", label: "Show Slant Height", type: "checkbox" },
      { name: "show3DAxes", label: "Show 3D Axes", type: "checkbox" }
    ],
    drag_points: ['center', 'radius', 'height'],
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z"
  },
  {
    id: "cuboid-diagonals-3d-002",
    category_id: "3d-geometry",
    name: "Cuboid with Diagonals",
    description: "3D cuboid with visible face and space diagonals",
    coordinates: "Base at origin, height h, width w, depth d with diagonal lines",
    type: "3D",
    difficulty_level: "intermediate",
    tags: ["cuboid", "3d", "diagonals", "geometry", "advanced"],
    default_params: {
      centerX: 200,
      centerY: 150,
      width: 100,
      height: 80,
      depth: 60,
      baseFill: "lightgray",
      sideFill: "lightblue",
      topFill: "lightgreen",
      stroke: "black",
      strokeWidth: 2,
      showFaceDiagonals: true,
      showSpaceDiagonals: true,
      showDimensions: true,
      show3DAxes: true
    },
    parameter_config: [
      { name: "centerX", label: "Center X", type: "number", min: 50, max: 350 },
      { name: "centerY", label: "Center Y", type: "number", min: 50, max: 250 },
      { name: "width", label: "Width (w)", type: "number", min: 40, max: 200 },
      { name: "height", label: "Height (h)", type: "number", min: 30, max: 150 },
      { name: "depth", label: "Depth (d)", type: "number", min: 20, max: 120 },
      { name: "baseFill", label: "Base Color", type: "color" },
      { name: "sideFill", label: "Side Color", type: "color" },
      { name: "topFill", label: "Top Color", type: "color" },
      { name: "stroke", label: "Edge Color", type: "color" },
      { name: "strokeWidth", label: "Edge Width", type: "number", min: 1, max: 5 },
      { name: "showFaceDiagonals", label: "Show Face Diagonals", type: "checkbox" },
      { name: "showSpaceDiagonals", label: "Show Space Diagonals", type: "checkbox" },
      { name: "showDimensions", label: "Show Dimensions", type: "checkbox" },
      { name: "show3DAxes", label: "Show 3D Axes", type: "checkbox" }
    ],
    drag_points: ['center', 'width', 'height', 'depth'],
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z"
  },
  {
    id: "intersecting-planes-triangle-3d-003",
    category_id: "3d-geometry",
    name: "Intersecting Planes with Triangle",
    description: "Two intersecting planes with a triangle formed at intersection",
    coordinates: "Planes intersect at line, triangle vertices on intersection",
    type: "3D",
    difficulty_level: "advanced",
    tags: ["planes", "3d", "intersection", "triangle", "geometry", "advanced"],
    default_params: {
      centerX: 200,
      centerY: 150,
      plane1Angle: 45,
      plane2Angle: 135,
      triangleSize: 60,
      planeFill: "rgba(100, 150, 255, 0.3)",
      triangleFill: "lightgreen",
      stroke: "black",
      strokeWidth: 2,
      showIntersection: true,
      showTriangle: true,
      showNormals: true,
      show3DAxes: true
    },
    parameter_config: [
      { name: "centerX", label: "Center X", type: "number", min: 50, max: 350 },
      { name: "centerY", label: "Center Y", type: "number", min: 50, max: 250 },
      { name: "plane1Angle", label: "Plane 1 Angle", type: "number", min: 0, max: 180 },
      { name: "plane2Angle", label: "Plane 2 Angle", type: "number", min: 0, max: 180 },
      { name: "triangleSize", label: "Triangle Size", type: "number", min: 20, max: 120 },
      { name: "planeFill", label: "Plane Color", type: "color" },
      { name: "triangleFill", label: "Triangle Color", type: "color" },
      { name: "stroke", label: "Edge Color", type: "color" },
      { name: "strokeWidth", label: "Edge Width", type: "number", min: 1, max: 5 },
      { name: "showIntersection", label: "Show Intersection", type: "checkbox" },
      { name: "showTriangle", label: "Show Triangle", type: "checkbox" },
      { name: "showNormals", label: "Show Normals", type: "checkbox" },
      { name: "show3DAxes", label: "Show 3D Axes", type: "checkbox" }
    ],
    drag_points: ['center', 'plane1', 'plane2', 'triangle'],
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z"
  },
  {
    id: "sphere-cross-section-3d-004",
    category_id: "3d-geometry",
    name: "Sphere Cross-Section",
    description: "3D sphere with visible cross-sectional circle",
    coordinates: "Sphere center at origin, cross-section at height h from center",
    type: "3D",
    difficulty_level: "advanced",
    tags: ["sphere", "3d", "cross-section", "geometry", "advanced"],
    default_params: {
      centerX: 280,
      centerY: 150,
      sphereRadius: 100,
      diskRadius: 60,
      diskOffsetY: -77,
      showSphere: true,
      showDisk: true,
      showRadius: true,
      sphereColor: "rgba(139,69,19,0.8)",
      diskColor: "rgba(128,128,128,0.6)",
      radiusColor: "red",
      stroke: "black",
      strokeWidth: 2
    },
    parameter_config: [
      { name: "centerX", label: "Center X", type: "number", min: 0, max: 400 },
      { name: "centerY", label: "Center Y", type: "number", min: 0, max: 300 },
      { name: "sphereRadius", label: "Sphere Radius", type: "number", min: 30, max: 150 },
      { name: "diskRadius", label: "Disk Radius", type: "number", min: 10, max: 150 },
      { name: "diskOffsetY", label: "Disk Offset Y", type: "number", min: -150, max: 150 },
      { name: "showSphere", label: "Show Sphere", type: "checkbox" },
      { name: "showDisk", label: "Show Disk", type: "checkbox" },
      { name: "showRadius", label: "Show Radius", type: "checkbox" },
      { name: "sphereColor", label: "Sphere Color", type: "color" },
      { name: "diskColor", label: "Disk Color", type: "color" },
      { name: "radiusColor", label: "Radius Color", type: "color" },
      { name: "stroke", label: "Edge Color", type: "color" },
      { name: "strokeWidth", label: "Edge Width", type: "number", min: 1, max: 5 }
    ],
    drag_points: ['center', 'crossSection', 'radius'],
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z"
  },
  {
    id: "point-to-plane-geometry-3d-005",
    category_id: "3d-geometry",
    name: "Point to Plane Geometry",
    description: "Point in 3D space with distance to plane and perpendicular projection",
    coordinates: "Point P(x,y,z), plane equation ax+by+cz+d=0, projection P'",
    type: "3D",
    difficulty_level: "advanced",
    tags: ["point", "3d", "plane", "projection", "geometry", "advanced"],
    default_params: {
      centerX: 200,
      centerY: 150,
      pointX: 250,
      pointY: 100,
      pointZ: 50,
      planeA: 1,
      planeB: 1,
      planeC: 1,
      planeD: -200,
      pointFill: "red",
      projectionFill: "blue",
      planeFill: "rgba(100, 150, 255, 0.3)",
      stroke: "black",
      strokeWidth: 2,
      showPoint: true,
      showProjection: true,
      showDistance: true,
      show3DAxes: true
    },
    parameter_config: [
      { name: "centerX", label: "Center X", type: "number", min: 50, max: 350 },
      { name: "centerY", label: "Center Y", type: "number", min: 50, max: 250 },
      { name: "pointX", label: "Point X", type: "number", min: 50, max: 350 },
      { name: "pointY", label: "Point Y", type: "number", min: 50, max: 250 },
      { name: "pointZ", label: "Point Z", type: "number", min: -100, max: 100 },
      { name: "planeA", label: "Plane A", type: "number", min: -2, max: 2, step: 0.1 },
      { name: "planeB", label: "Plane B", type: "number", min: -2, max: 2, step: 0.1 },
      { name: "planeC", label: "Plane C", type: "number", min: -2, max: 2, step: 0.1 },
      { name: "planeD", label: "Plane D", type: "number", min: -300, max: 300 },
      { name: "pointFill", label: "Point Color", type: "color" },
      { name: "projectionFill", label: "Projection Color", type: "color" },
      { name: "planeFill", label: "Plane Color", type: "color" },
      { name: "stroke", label: "Edge Color", type: "color" },
      { name: "strokeWidth", label: "Edge Width", type: "number", min: 1, max: 5 },
      { name: "showPoint", label: "Show Point", type: "checkbox" },
      { name: "showProjection", label: "Show Projection", type: "checkbox" },
      { name: "showDistance", label: "Show Distance", type: "checkbox" },
      { name: "show3DAxes", label: "Show 3D Axes", type: "checkbox" }
    ],
    drag_points: ['point', 'plane', 'projection'],
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z"
  }
];
